// actionType
const SET_USER_INFO = 'SET_USER_INFO'
// 新闻
const SET_NEWS = 'SET_NEWS'

// 从哪进入课程详情页
const SET_FROM = 'SET_FROM'

// 当前导航选中谁
const SET_NAV_INDEX = 'SET_NAV_INDEX'

// 测试saga用
const SET_USER_LIST = 'SET_USER_LIST'

// actionCreator
export const setUserInfo = (val: any) =>({ type: SET_USER_INFO, payload: val})
export const setNews = (val: any) =>({ type: SET_NEWS, payload: val})
export const setFrom = (val: any) =>({ type: SET_FROM, payload: val})
export const setNavIndex = (val: any) =>({ type: SET_NAV_INDEX, payload: val})


